import React from 'react';
import { 
  Brain, 
  Laptop, 
  Shield, 
  Award, 
  Target, 
  LineChart,
  Users,
  Lock,
  Scroll,
  UserCheck
} from 'lucide-react';

const SectionTitle = ({ subtitle, title, align = 'left' }) => (
  <div className={`mb-12 ${align === 'center' ? 'text-center' : ''}`}>
    <div className={`flex items-center gap-2 mb-3 ${align === 'center' ? 'justify-center' : ''}`}>
      <div className="w-12 h-0.5 bg-[#F49611]"></div>
      <span className="text-[#F49611] font-medium uppercase tracking-wider text-sm">{subtitle}</span>
    </div>
    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">{title}</h2>
  </div>
);

const ApproachCard = ({ Icon, title, description, index }) => (
  <div className="group">
    <div className="relative p-8 rounded-xl bg-white border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      <div className="absolute top-0 right-0 w-24 h-24 bg-[#E8EEF6] rounded-bl-full -z-10 group-hover:bg-[#F49611] transition-colors duration-300"></div>
      <div className="flex items-start gap-6">
        <div className="relative">
          <div className="w-12 h-12 rounded-xl bg-[#E8EEF6] group-hover:bg-[#F49611] transition-colors duration-300 flex items-center justify-center">
            <Icon className="w-6 h-6 text-[#113262] group-hover:text-white transition-colors duration-300" />
          </div>
          <span className="absolute -bottom-4 -right-4 text-4xl font-bold text-[#E8EEF6] group-hover:text-[#F49611]/10 transition-colors duration-300">
            {String(index).padStart(2, '0')}
          </span>
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-[#113262] mb-3">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  </div>
);

const MainContent = () => {
  return (
    <div className="space-y-32">
      {/* Unique Approach Section */}
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <SectionTitle
          subtitle="Our Unique Approach"
          title="Our Unique Approach to Post Retirement Planning"
        />
        <div className="grid md:grid-cols-2 gap-8">
          {[
            {
              icon: Brain,
              title: "Deep Financial Acumen",
              description: "We bring our vast expertise in stocks and mutual funds into retirement solutions"
            },
            {
              icon: Laptop,
              title: "Integrated Planning",
              description: "Use our tech synergy to plan, execute, and monitor your retirement finances."
            },
            {
              icon: Award,
              title: "Certified Excellence",
              description: "Our ISO 9001 certified processes guarantee top-notch retirement planning services."
            },
            {
              icon: Shield,
              title: "Fiduciary Commitment",
              description: "Registered with SEBI, our guidance is always in your best interest."
            },
            {
              icon: Target,
              title: "Holistic Planning",
              description: "From assets to goals, every element is integrated into your retirement plan."
            },
            {
              icon: Brain,
              title: "Unbiased Recommendations",
              description: "We use data analytics to provide objective retirement planning advice."
            }
          ].map((approach, index) => (
            <ApproachCard
              key={index}
              Icon={approach.icon}
              title={approach.title}
              description={approach.description}
              index={index + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainContent;